import React from 'react';

const Offer = () => {
  return (
    <section className="offer section">
      <div className="offer-bg">
        <div className="offer-data">
          <h2 className="offer-title">Special Offer</h2>
          <p className="offer-description">Special offerts discounts for women this week only</p>
          <a href="#" className="button">SHOP NOW</a>
        </div>
      </div>
    </section>
  );
};

export default Offer;

